import { cn } from "~/lib/utils";

type ProgressLineProps = {
    className?: string;
};

const ProgressLine = ({ className }: ProgressLineProps) => {
    return (
        <div className={cn("absolute left-[15.5px] top-0 bottom-0 w-px bg-primary300", className)} />
    );
};

export default ProgressLine;
